






import * as Common from "../commons/common"
import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import http from "../plugins/http";

export default defineComponent({
  setup(props, context){

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      
      const isSSO = context.root.$store.state.isSSO;
      const currentUser = context.root.$store.state.currentUser;
      const role = currentUser?.role;
      const accessToken = Common.getCookieValue(document.cookie, "access_token");
      // 画面状態が消えていてもログアウトAPI呼び出しと元のログイン画面への遷移を継続
      const currentUserId = currentUser?.id || Common.getCookieValue(document.cookie, "smarky_user_id");
      const schoolUrlPrefix = context.root.$store.state.school_url_prefix || Common.getCookieValue(document.cookie, "school_url_prefix");
      const isStudent = role == Common.RoleEnum.Student || (!role && !!schoolUrlPrefix);

      try {
        // Cookieを消す前に現在の端末セッションをログアウト
        if(accessToken && currentUserId){
          await http.post(
            `/api/logout/${currentUserId}/`,
            {access_token: accessToken},
            {timeout: 2000}
          );
        }
      } catch {
        // API失敗時もCookie削除とログイン画面への遷移を継続
      } finally {
        // APIの成否にかかわらず画面上のログアウトを継続
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        document.cookie = 'smarky_is_parent=';
      }

      const errorKindQuery = context.root.$route.query.errorKind ? `?error_kind=${context.root.$route.query.errorKind}` : "";

      if(isStudent){
        context.root.$store.commit("setCurrentUser", null);
        context.root.$store.commit("setGauthCredentials", null);
        context.root.$store.commit("setStudentCode", null);
        context.root.$store.commit("setStudentName", null);

        if(isSSO){
          alert("ログアウトしました。ブラウザを終了します。");
          window.close();
        }else{
          if(schoolUrlPrefix){
            window.location.href = `/#/${schoolUrlPrefix}/student_site/sign_in${errorKindQuery}`;
          }else{
            alert("ログインページからやり直してください。");
          }
        }
      }else{
        context.root.$store.commit("setCurrentUser", null);
        if(isSSO){
          alert("ログアウトしました。ブラウザを終了します。");
          window.close();
        }else{
          window.location.href = `/#/${errorKindQuery}`;
        }
      }
    });
  }
})
